export function useSearchProductGetters(): SearchProductGetters {
  // Getter for offer price details
  const getOfferPrice = (product: ProductSearchContent) => {
    return product.offerPrice;
  };

  // Getter for offer price details
  const getOfferPriceExternalId = (product: ProductSearchContent) => {
    return product.offerPrice.externalId;
  };

  // Getter for offer details
  const getOffer = (product: ProductSearchContent) => {
    return product.offer;
  };

  // Getter for variant details
  const getVariant = (product: ProductSearchContent) => {
    return product.variant;
  };

  // Getter for product details
  const getProductDetails = (product: ProductSearchContent) => {
    return product.product;
  };

  // Getter for supplier details
  const getSupplier = (product: ProductSearchContent) => {
    return product.supplier;
  };

  // Getter for product attributes
  const getAttributes = (product: ProductSearchContent) => {
    return product.attributes;
  };

  // Getter for picture URLs
  const getPictureUrls = (product: ProductSearchContent) => {
    return product.variant.pictureUrls ?? [];
  };

  // Getter for main picture URL
  const getMainPictureUrl = (product: ProductSearchContent) => {
    return product.variant.pictureUrls.filter((pic) => pic.main) ?? null;
  };

  // --- Additional Product Details Getters ---

  // Getter for product ID
  const getProductId = (product: ProductSearchContent) => {
    return product.product.id;
  };

  // Getter for product SKU
  const getProductSku = (product: ProductSearchContent) => {
    return product.product.sku;
  };

  // Getter for product External ID
  const getProductExternalId = (product: ProductSearchContent) => {
    return product.product.externalId;
  };

  // Getter for product name
  const getProductName = (product: ProductSearchContent) => {
    return product.product.name;
  };

  // Getter for product description
  const getProductDescription = (product: ProductSearchContent) => {
    return product.product?.description;
  };

  // Getter for product brand
  const getProductBrand = (product: ProductSearchContent) => {
    return product.product.brand;
  };

  // Getter for product tags
  const getProductTags = (product: ProductSearchContent) => {
    return product.product.tags ?? [];
  };

  // Getter for main product picture URL (if exists)
  const getMainProductPictureUrl = (product: ProductSearchContent) => {
    return product.product.mainPictureUrl ?? null;
  };

  // Getter for product variant name
  const getProductVariantName = (product: ProductSearchContent) => {
    return product?.variant.name;
  };

  // Getter for paginated products
  const getProductsPaginated = (searchResponse: SearchProductsResponse) => {
    return searchResponse.products;
  };

  // Getter for product content
  const getProductsContent = (searchResponse: SearchProductsResponse) => {
    return searchResponse.products.content;
  };

  const getOfferUnitPrice = (product: ProductSearchContent) => {
    return product.offerPrice.unitPrice;
  };

  const getOfferMinQuantity = (product: ProductSearchContent) => {
    return product.offer.minOrderQuantity;
  };

  const getOfferMaxQuantity = (product: ProductSearchContent): number => {
    return product.offer.maxOrderQuantity ?? 10000000;
  };
  const getOfferStock = (product: ProductSearchContent) => {
    return product.offer.stock;
  };

  const getOfferQuantityPerPack = (product: ProductSearchContent) => {
    return product.offerPrice.itemPerPack;
  };

  return {
    getOfferPrice,
    getOfferPriceExternalId,
    getOffer,
    getVariant,
    getProductDetails,
    getSupplier,
    getAttributes,
    getPictureUrls,
    getMainPictureUrl,
    getProductId,
    getProductSku,
    getProductExternalId,
    getProductName,
    getProductDescription,
    getProductBrand,
    getProductTags,
    getMainProductPictureUrl,
    getProductVariantName,
    getProductsPaginated,
    getProductsContent,
    getOfferUnitPrice,
    getOfferMinQuantity,
    getOfferMaxQuantity,
    getOfferStock,
    getOfferQuantityPerPack,
  };
}
